import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/LaC_logo_duo_light_4.svg'
import _imports_1 from '@/assets/images/circle-down-arrow.svg'


const _hoisted_1 = { class: "mainJumbotron" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"logo-div\"><img class=\"logo-img\" src=\"" + _imports_0 + "\"></div><div class=\"circle-div\"><a href=\"#approach\"><img class=\"circle-image\" src=\"" + _imports_1 + "\"></a></div>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}